import React from 'react'
import T from 'prop-types'
import { SvgIcon } from '@mui/material'

export default function SixtIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 1024 1024"
      >
        <rect width="1024" height="1024" rx="230" fill="#FF5000" />
        <rect width="1024" height="1024" fill="#FF5000" />
        <path
          d="M427.923 384.856C410.166 387.17 386.282 387.159 366.954 386.993V450.883H403.045C452.368 450.883 571.807 440.249 607.521 323.757H531.322C508.855 368.093 470.494 379.405 427.923 384.856Z"
          fill="white"
        />
        <path
          d="M902 373.997V439.989H827.689V637.353H750.059V439.989H691.935L641.165 512.221L740.632 637.35H644.103L590 563.923L533.123 637.35L366.95 637.353V472.495H443.001V631.244L540.891 512.221L500.59 462.255C506.537 460.269 513.119 457.707 518.751 455.327C537.262 447.505 553.516 435.579 568.064 423.642L590 455.013L649.197 373.997H902ZM226.806 643.867C302.936 643.523 352.579 620.238 352.579 557.588C352.579 445.503 196.606 493.301 196.606 449.251C196.606 434.119 213.072 428.026 237.617 428.026C267.684 428.026 306.469 438.149 336.545 447.899V384.307C311.568 377.132 275.981 368.971 237.391 368.971C150.474 368.971 122.099 409.897 122 454.198C121.75 566.649 275.381 518.763 275.381 562.446C275.381 577.154 259.091 583.762 226.492 583.787C194.405 583.787 160.103 575.992 124.862 564.355V627.933C144.192 635.791 174.739 643.867 226.806 643.867Z"
          fill="#1A1A1A"
        />
      </svg>
    </SvgIcon>
  )
}

SixtIcon.propTypes = {
  label: T.string,
  handleClick: T.func,
  showLabel: T.bool,
}
